import React from "react";
import HotshotsBook from "../../containers/Hotshots/HotshotsBook";
import { Helmet } from "react-helmet";

const Hotshots = () => {
  return (
    <>
      <Helmet>
        <title>Hotshots - Scripture Union Thailand</title>
        <meta
          name="description"
          content="SU THAILAND ทำพันธกิจร่วมกับคริสตจักรและโรงเรียน เพื่อให้เด็กเยาวชนและครอบครัว ได้ยินข่าวประเสริฐของพระเจ้า"
        />
      </Helmet>
      <HotshotsBook />
    </>
  );
};

export default Hotshots;
